import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/state';

//Component
import { DynamicTypography, GridContainer, GridItem } from '../../components';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { FiservForm } from 'components/FiservForm';

//Helper
import { convertNumberToAmount } from '../../utils/stringHelper';

interface IProps {
  handleFiservPay: () => void;
  onFiservConfigRetrieved: (isCompleted: boolean) => void;
}

export const FiservSummaryCharges: React.FC<IProps> = ({handleFiservPay, onFiservConfigRetrieved}) => {
    const { selectedReservation } = useSelector((state: RootState) => state.reservationState);   
    const [isFiservConfigRetrieved, setIsFiservConfigRetrieved] = React.useState(false);

    return (
        <GridContainer
            spacing={3}
            alignItems="center"
            justifyContent="center"
            direction="column"
            style={{ paddingTop: '18px', paddingLeft: '18px', paddingRight: '18px', marginBottom: '56px' }}
        >
        <FiservForm onRetrieveConfigCompleted={(c)=>{setIsFiservConfigRetrieved(c); onFiservConfigRetrieved(c)}} onSubmit={handleFiservPay} isPreAuthCard={true}/>
        <GridItem xs={12}>
            <DynamicTypography
              color="textPrimary"
              align="center"
              variant="subtitle2"
              content="Please review your amount to pay before proceeding with the payment.<br>Kindly proceed to the secure payment gateway by clicking the 'PAY' button below."
            ></DynamicTypography>
        </GridItem>
          
          {isFiservConfigRetrieved ? (
              <GridItem xs={12}>
              <Typography color="textPrimary" align="center" variant="h4">
                <b>{`${selectedReservation?.currency} ${convertNumberToAmount(selectedReservation?.totalPrice)}`}</b>
              </Typography>
            </GridItem>
          ) :
            <GridItem>
              <CircularProgress />
            </GridItem>
          }
        </GridContainer>
    );
};
